import Header from './header'
import Content from './content'
import Footer from './footer'
import './style.css'





function Home (){
    return(
        <>
           <Header />
           <Content />
           <Footer />
        </>
    )
}


export default Home